import { Activity, CreditCard, FileText, Mail, RefreshCw } from 'lucide-react';

const ICON_MAP = {
  invoice_created: FileText,
  invoice_paid: CreditCard,
  payment_received: CreditCard,
  quote_emailed: Mail,
  quote_to_invoice: RefreshCw,
  client_created: Activity,
  deposit_paid: CreditCard,
};

export const ClientActivityTimeline = ({ activities }) => {
  if (!activities?.length) {
    return (
      <div className="text-center py-12 text-gray-500" data-testid="client-activity-empty-state">
        <Activity className="w-12 h-12 mx-auto mb-3 text-gray-300" />
        <p>No activity recorded yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="client-activity-timeline">
      {activities.map((activity) => {
        const Icon = ICON_MAP[activity.type] || Activity;
        return (
          <div key={activity.id} className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#014DB7]/10 text-[#014DB7] flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-3">
                  <h4 className="font-semibold text-[#0A1628]">{activity.title || 'Activity'}</h4>
                  <span className="text-xs text-gray-400">{activity.created_at ? new Date(activity.created_at).toLocaleString() : '-'}</span>
                </div>
                <p className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{activity.description || 'No description provided.'}</p>
                {activity.metadata && Object.keys(activity.metadata).length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {Object.entries(activity.metadata).map(([key, value]) => (
                      <span key={key} className="px-2.5 py-1 rounded-full bg-gray-100 text-gray-600 text-xs">
                        {key}: {Array.isArray(value) ? value.length : String(value)}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};